/**
 * Get admin jobs with RBAC using Edge Function
 * Only accessible to OUTLET_MANAGER and ORG_ADMIN roles
 */

import { supabase } from '../../../lib/supabaseClient';
import { ApiResponse } from '../../../types/api';
import { CreateUserPayload, CreateUserResponse, DeleteUserResponse, Job, Employee } from '../../../types';
import { handleEdgeFunctionError } from '../../../utils/edgeFunctionUtils';


/**
 * Map admin user API response to UI format
 */
const mapAdminUser = (apiUser: any): Employee => {
  return {
    id: apiUser.user_id,
    ...apiUser,
  };
};

export async function getAdminJobsWithEdgeFunction(): Promise<ApiResponse<Job[]>> {
  try {
    const { data, error } = await supabase.functions.invoke('get-admin-jobs', {
      body: {},
    });

    if (error) {
      console.error('[Edge Function Error] getAdminJobs:', error);
      const extractedError = await handleEdgeFunctionError(error);
      return { data: [], error: extractedError };
    }

    return { data: data?.data || [], error: null };
  } catch (err) {
    console.error('[Edge Function Exception] getAdminJobs:', err);
    return { data: [], error: err };
  }
}

export const getAdminUsersWithEdgeFunction = async (): Promise<ApiResponse<Employee[]>> => {
  try {
    const { data, error } = await supabase.functions.invoke('get-admin-pocs', {
      body: {},
    });

    if (error) {
      console.error('[Edge Function Error] getAdminUsers:', error);
      const extractedError = await handleEdgeFunctionError(error);
      return { data: [], error: extractedError };
    }

    // Map API response to UI format
    const mappedData = (data?.data || []).map(mapAdminUser);
    return { data: mappedData, error: data?.error || null };
  } catch (err) {
    console.error('[Edge Function Exception] getAdminUsers:', err);
    return { data: [], error: err };
  }
}

export async function createUserWithEdgeFunction(userData: CreateUserPayload): Promise<ApiResponse<CreateUserResponse>> {
  try {
    const { data, error } = await supabase.functions.invoke('create-poc', {
      body: userData,
    });

    if (error) {
      console.error('[Edge Function Error] createUser:', error);
      const extractedError = await handleEdgeFunctionError(error);
      return { data: null, error: extractedError };
    }

    return { data: data?.data || null, error: data?.error || null };
  } catch (err) {
    console.error('[Edge Function Exception] createUser:', err);
    return { data: null, error: err };
  }
}

export async function deleteUserWithEdgeFunction(userId: string): Promise<ApiResponse<DeleteUserResponse>> {
  try {
    const { data, error } = await supabase.functions.invoke('delete-user', {
      body: {
        user_id: userId,
      },
    });
    if (error) {
      console.error('[Edge Function Error] deleteUser:', error);
      const extractedError = await handleEdgeFunctionError(error);
      return { data: null, error: extractedError };
    }

    return { data: data?.data || null, error: data?.error || null };
  } catch (err) {
    console.error('[Edge Function Exception] deleteUser:', err);
    return { data: null, error: err };
  }
}
